module.exports = __webpack_public_path__ + "media/images/slider_h1_01-5fb655fdbcfb5ed6400b41c3c19e3744.png";